import { render, staticRenderFns } from "./expertDetail.vue?vue&type=template&id=54bab420&scoped=true"
import script from "./expertDetail.vue?vue&type=script&lang=js"
export * from "./expertDetail.vue?vue&type=script&lang=js"
import style0 from "./expertDetail.vue?vue&type=style&index=0&id=54bab420&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54bab420",
  null
  
)

export default component.exports